import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';

export type UserInvitedPayload = UserPayload;

export type UserInvitedAction = {
	type: 'USER_INVITED';
	payload: UserInvitedPayload;
	accountId: number;
};

export default (payload: UserInvitedPayload, accountId: number): UserInvitedAction => ({
	type: 'USER_INVITED',
	payload,
	accountId,
});
